import {NgModule} from '@angular/core';
import {NpiService} from './npi.service';

@NgModule({
    providers: [NpiService]
})
export class NpiModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/npi/npi.module.ts